import React from "react";
import { IoMdArrowDropleft } from "react-icons/io";
const PasswordToolTip = ({ containerRef }) => {
  const passwordInfo = [
    "At least 12 characters",
    "At least 1 uppercase letter",
    "At least 1 lowercase letter",
    "At least 1 number",
    "At least 1 special character",
  ];
  return (
    <div ref={containerRef} className="password-info">
      <IoMdArrowDropleft className="password-info-arrow" />
      {passwordInfo.map((item, index) => (
        <p key={index} className="password-info-text">
          {item}
        </p>
      ))}
    </div>
  );
};
export default PasswordToolTip;
